import p1_img from "./product_1.png";
import p2_img from "./product_2.png";
import p3_img from "./product_3.png";
import p4_img from "./product_4.png";
import p5_img from "./product_5.png";
import p6_img from "./product_6.png";
import p7_img from "./product_7.png";
import p8_img from "./product_8.png";
import p9_img from "./product_9.png";
import p10_img from "./product_10.png";
import p11_img from "./product_11.png";
import p12_img from "./product_12.png";
import p13_img from "./product_13.png";
import p14_img from "./product_14.png";
import p15_img from "./product_15.png";
import p16_img from "./product_16.png";
import p17_img from "./product_17.png";
import p18_img from "./product_18.png";
import p19_img from "./product_19.png";
import p20_img from "./product_20.png";
import p21_img from "./product_21.png";
import p22_img from "./product_22.png";
import p23_img from "./product_23.png";
import p24_img from "./product_24.png";
import p25_img from "./product_25.png";
import p26_img from "./product_26.png";
import p27_img from "./product_27.png";
import p28_img from "./product_28.png";
import p29_img from "./product_29.png";
import p30_img from "./product_30.png";
import p31_img from "./product_31.png";
import p32_img from "./product_32.png";
import p33_img from "./product_33.png";
import p34_img from "./product_34.png";
import p35_img from "./product_35.png";
import p36_img from "./product_36.png";

let all_product = [
  {
    id: 1,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p1_img,
    new_price: 50.0,
    old_price: 80.5,
    description:
      "Elevate your style with this sophisticated Striped Flutter Sleeve Blouse. Featuring an overlap collar and a peplum hem, it's perfect for a trendy and chic look.",
  },
  {
    id: 2,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p2_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Make a fashion statement with this elegant Striped Flutter Sleeve Peplum Hem Blouse. The overlap collar adds a touch of glamour, making it a versatile choice for any occasion.",
  },
  {
    id: 3,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p3_img,
    new_price: 60.0,
    old_price: 100.5,
    description:
      "Step out in style with this Striped Flutter Sleeve Blouse. The peplum hem and overlap collar create a flattering silhouette, making it a wardrobe essential for any fashion-forward woman.",
  },
  {
    id: 4,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p4_img,
    new_price: 100.0,
    old_price: 150.0,
    description:
      "Enhance your wardrobe with this stunning Striped Flutter Sleeve Peplum Hem Blouse. The overlap collar and peplum hem add a touch of sophistication, making it perfect for special occasions.",
  },
  {
    id: 5,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p5_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Achieve a polished look with this Striped Flutter Sleeve Blouse. The overlap collar and peplum hem create a feminine silhouette, making it a must-have for any fashion-forward woman.",
  },
  {
    id: 6,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p6_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Upgrade your wardrobe with this stylish Striped Flutter Sleeve Peplum Hem Blouse. The overlap collar adds a touch of sophistication, making it a versatile choice for both casual and formal occasions.",
  },
  {
    id: 7,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p7_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Make a statement with this chic Striped Flutter Sleeve Blouse. The overlap collar and peplum hem add a touch of elegance, making it perfect for any fashion-forward woman.",
  },
  {
    id: 8,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p8_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Elevate your style with this sophisticated Striped Flutter Sleeve Peplum Hem Blouse. The overlap collar creates a flattering neckline, making it a timeless addition to your wardrobe.",
  },
  {
    id: 9,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p9_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Step out in confidence with this Striped Flutter Sleeve Blouse. The overlap collar and peplum hem add a modern twist, making it a stylish choice for any occasion.",
  },
  {
    id: 10,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p10_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Enhance your wardrobe with this elegant Striped Flutter Sleeve Peplum Hem Blouse. The overlap collar and peplum hem create a flattering silhouette, perfect for a sophisticated look.",
  },
  {
    id: 11,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p11_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Make a style statement with this Striped Flutter Sleeve Blouse. The overlap collar and peplum hem add a touch of flair, making it a versatile choice for any fashion-conscious woman.",
  },
  {
    id: 12,
    name: "Striped Flutter Sleeve Overlap Collar Peplum Hem Blouse",
    category: "women",
    image: p12_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Upgrade your wardrobe with this chic Striped Flutter Sleeve Peplum Hem Blouse. The overlap collar adds a touch of sophistication, making it a timeless piece for any stylish woman.",
  },
  {
    id: 13,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p13_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Stay on trend with this Men's Green Slim Fit Bomber Jacket. The zippered design adds a modern touch, making it a stylish choice for casual outings.",
  },
  {
    id: 14,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p14_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Elevate your casual look with this Men's Green Solid Bomber Jacket. The full-zip design and slim fit silhouette make it a must-have for any fashion-conscious man.",
  },
  {
    id: 15,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p15_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Make a statement with this Men's Green Solid Slim Fit Bomber Jacket. The full-zip design and stylish silhouette add a contemporary edge to your casual wardrobe.",
  },
  {
    id: 16,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p16_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Upgrade your outerwear with this Men's Green Solid Slim Fit Bomber Jacket. The full-zip design and slim fit silhouette make it a versatile and stylish choice for any casual occasion.",
  },
  {
    id: 17,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p17_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Achieve a sleek and modern look with this Men's Green Solid Bomber Jacket. The full-zip design and slim fit silhouette add a contemporary edge to your casual wardrobe.",
  },
  {
    id: 18,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p18_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Elevate your style with this Men's Green Solid Slim Fit Bomber Jacket. The full-zip design and stylish silhouette make it a versatile and on-trend addition to your wardrobe.",
  },
  {
    id: 19,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p19_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Make a fashion statement with this Men's Green Solid Bomber Jacket. The full-zip design and slim fit silhouette add a contemporary touch to your casual ensemble.",
  },
  {
    id: 20,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p20_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Step out in style with this Men's Green Solid Slim Fit Bomber Jacket. The full-zip design and slim fit silhouette make it a versatile and modern choice for your casual wardrobe.",
  },
  {
    id: 21,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p21_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Upgrade your outerwear collection with this Men's Green Solid Bomber Jacket. The full-zip design and slim fit silhouette add a contemporary edge to your casual look.",
  },
  {
    id: 22,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p22_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Achieve a sleek and stylish look with this Men's Green Solid Slim Fit Bomber Jacket. The full-zip design and slim fit silhouette make it a versatile choice for any casual occasion.",
  },
  {
    id: 23,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p23_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Elevate your casual style with this Men's Green Solid Bomber Jacket. The full-zip design and slim fit silhouette add a modern touch to your outerwear collection.",
  },
  {
    id: 24,
    name: "Men Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "men",
    image: p24_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Make a statement with this Men's Green Solid Slim Fit Bomber Jacket. The full-zip design and slim fit silhouette add a contemporary edge to your casual ensemble.",
  },
  {
    id: 25,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kid",
    image: p25_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Keep your little one warm and stylish with this Boys' Orange Colourblocked Hooded Sweatshirt. The vibrant color and hooded design make it perfect for playtime adventures.",
  },
  {
    id: 26,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kid",
    image: p26_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Add a pop of color to your child's wardrobe with this Boys' Orange Colourblocked Hooded Sweatshirt. The hooded design and vibrant color make it a playful and comfortable choice for any day.",
  },
  {
    id: 27,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kid",
    image: p27_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Keep your little one cozy and stylish with this Boys' Orange Colourblocked Hooded Sweatshirt. The bold color and comfortable design make it perfect for cool weather adventures.",
  },
  {
    id: 28,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kid",
    image: p28_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Make a statement with this Boys' Orange Colourblocked Hooded Sweatshirt. The vibrant color and hooded design add a playful touch, making it an essential for your child's wardrobe.",
  },
  {
    id: 29,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kid",
    image: p29_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Elevate your child's casual style with this Boys' Orange Colourblocked Hooded Sweatshirt. The bold color and hooded design make it a trendy and comfortable choice for any occasion.",
  },
  {
    id: 30,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kid",
    image: p30_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Upgrade your child's wardrobe with this Boys' Orange Colourblocked Hooded Sweatshirt. The vibrant color and hooded design add a playful element, making it perfect for everyday wear.",
  },
  {
    id: 31,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kid",
    image: p31_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Achieve a stylish and cozy look for your child with this Boys' Orange Colourblocked Hooded Sweatshirt. The vibrant color and hooded design make it a versatile choice for any season.",
  },
  {
    id: 32,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kid",
    image: p32_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Keep your little one warm and trendy with this Boys' Orange Colourblocked Hooded Sweatshirt. The vibrant color and hooded design add a playful touch to their casual wardrobe.",
  },
  {
    id: 33,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kid",
    image: p33_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Add a burst of color to your child's ensemble with this Boys' Orange Colourblocked Hooded Sweatshirt. The hooded design and comfortable fit make it a must-have for playtime.",
  },
  {
    id: 34,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kid",
    image: p34_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Make a statement with this Boys' Orange Colourblocked Hooded Sweatshirt. The vibrant color and hooded design add a playful touch, making it a stylish choice for your little one.",
  },
  {
    id: 35,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kid",
    image: p35_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Elevate your child's casual look with this Boys' Orange Colourblocked Hooded Sweatshirt. The bold color and hooded design make it a trendy and comfortable choice for any day.",
  },
  {
    id: 36,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "kid",
    image: p36_img,
    new_price: 85.0,
    old_price: 120.5,
    description:
      "Upgrade your little one's wardrobe with this Boys' Orange Colourblocked Hooded Sweatshirt. The vibrant color and hooded design add a playful element, perfect for all-day comfort.",
  },
];

export default all_product;
